import { FC } from 'react';
import { Link } from 'react-router-dom';
import { UserIcon } from '../../ui/Icon/UserIcon';
import { IUserProfile } from '../../models/IUserProfile';

interface ProfileLinkProps {
    userProfile: IUserProfile | undefined;
    urlPathname: string;
    resize: boolean;
    logRegModal: boolean;
    setLogRegModal: (value: boolean) => void;
}

export const ProfileLink: FC<ProfileLinkProps> = ({ userProfile, urlPathname, resize, logRegModal, setLogRegModal }) => {
    const linkClasses = urlPathname === '/profile' ? "nav__link active" : "nav__link";

    if (resize) {
        return userProfile ? (
            <Link className={linkClasses} to={'/profile'}>
                <UserIcon userProfile={userProfile} />
            </Link>
        ) : (
            <button className={linkClasses} onClick={() => setLogRegModal(!logRegModal)}>
                <UserIcon userProfile={userProfile} />
            </button>
        );
    } else {
        return userProfile ? (
            <Link className={linkClasses} to={'/profile'}>
                {userProfile?.name}
            </Link>
        ) : (
            <button className={linkClasses} onClick={() => setLogRegModal(!logRegModal)}>
                Войти
            </button>
        );
    }
};